import Cookies from 'js-cookie';

const isDebugEnabled = window.spa_variables?.debugEnabled;

const isTripProviderInfoEnabled = () => Cookies.get('mockedShouldDisplayTripProviders') !== 'no';

export const shouldShowDebugProviderSystemBar = (providerSystems) =>
  isDebugEnabled && providerSystems && isTripProviderInfoEnabled();
